import { useRouter } from 'next/router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';
// Styles & Icons
import styles from './navLink.module.css';

const NavLink = ({
  value,
  path,
  icon,
  isSub,
  badgeContent,
  close,
  QADataTag = 'sideNavLink',
  setIsDrawerOpen,
}) => {
  const { push, asPath } = useRouter();

  const isActive =
    asPath.split('/')[1] === path.split('/')[1] || asPath === path
      ? `${styles.isActive}`
      : '';
  const isSubLink = isSub ? `${styles.isSub}` : '';

  const handleClick = () => {
    setIsDrawerOpen(false);
    close && close();
    push(path);
  };

  if (typeof icon === 'string') return null;

  return (
    <div
      className={`${styles.wrapper} ${isSubLink} ${isActive}`}
      data-core-qa={QADataTag}
      onClick={handleClick}
    >
      <FontAwesomeIcon
        icon={icon}
        width={16}
        height={'1.4em'}
        style={{ marginRight: 16, height: '12px', width: '12px' }}
      />
      <Box
        sx={{ display: 'flex', alignItems: 'center' }}
        data-core-qa={QADataTag + 'Text'}
      >
        {value}
        {badgeContent > 0 ? (
          <div className={styles.badge}>{`${badgeContent}`}</div>
        ) : null}
      </Box>
    </div>
  );
};

export default NavLink;
